import { createTheme, ThemeOptions } from '@mui/material'
import { ColorPartial, PaletteOptions as PaletteOptionsType } from '@mui/material/styles/createPalette'

import { lightShadows, darkShadows } from './shadows'

export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK'
}

export interface ExtendedThemeOptions extends ThemeOptions {
  palette: PaletteOptionsType & {
    blueGrey?: ColorPartial
  }
}

export const themesOptions: Record<string, ExtendedThemeOptions> = {
  [THEMES.LIGHT]: {
    palette: {
      mode: 'light',
      primary: {
        main: '#04567E',
        light: '#C7CED4',
        dark: '#5089A5',
        50: '#EEF6FF',
        100: '#C5DCF9',
        200: '#9FC8F6',
        300: '#78B2F3',
        600: '#006EFF',
        700: '#295EE3',
        800: '#295EE3'
      },
      secondary: {
        main: '#f50057'
      },
      text: {
        primary: '#344054',
        secondary: '#535C73',
        disabled: '#9AA4B2'
      },
      info: {
        main: '#697586'
      },
      error: {
        main: '#F44336'
      },
      warning: {
        main: '#E1772E',
        300: '#FEC84B',
        500: '#F2A13B',
        600: '#EE9537',
        700: '#E88632',
        800: '#E1772E'
      },
      success: {
        main: '#027A48',
        light: '#7BC67E',
        dark: '#12B76A',
        50: '#ECFDF3',
        100: '#D1FADF',
        300: '#6CE9A6',
        500: '#12B76A',
        600: '#039855',
        700: '#027A48'
      },
      blueGrey: {
        400: '#C7CED4',
        500: '#A6B1BB'
      },
      grey: {
        50: '#F8FAFC',
        100: '#F7F7F7',
        200: '#E3E8EF',
        300: '#CDD5DF',
        400: '#9AA4B2',
        500: '#697586',
        700: '#535C73',
        800: '#42495C',
        900: '#323848'
      }
    },
    shadows: lightShadows
  },
  [THEMES.DARK]: {
    palette: {
      background: {
        default: '#171c24',
        paper: '#222b36'
      },
      divider: 'rgba(145, 158, 171, 0.24)',
      error: {
        contrastText: '#ffffff',
        main: '#f44336'
      },
      mode: 'dark',
      primary: {
        contrastText: '#ffffff',
        main: '#688eff'
      },
      success: {
        contrastText: '#ffffff',
        main: '#4caf50'
      },
      text: {
        primary: '#ffffff',
        secondary: '#919eab'
      },
      warning: {
        contrastText: '#ffffff',
        main: '#ff9800'
      }
    },
    shadows: darkShadows
  }
}

export const PaletteOptions = createTheme(themesOptions)
